<template>
  <div class="basic_style_asset customer_spotlight_card as_list">
    <div class="wrapper no-footer">
      <div class="header">
        <div class="asset-type" v-if="is_customer_spotlight">
          <UserIcon />
          <h6>Customer Spotlight</h6>
        </div>
        <div class="asset-type" v-else-if="is_account_spotlight">
          <AccountIcon />
          <h6>Account Spotlight</h6>
        </div>
        <div class="asset-type" v-else-if="is_survey_spotlight">
          <SmallSurveySpotlightIcon />
          <h6>Survey Spotlight</h6>
        </div>
        <div class="asset-type" v-else-if="is_case_study">
          <b-icon icon="file-person-fill" />
          <h6>Case Study</h6>
        </div>
      </div>
      <h2>{{ content_asset.title }}</h2>
      <p class="date" v-if="content_asset.created_at">{{ formatted_date }}</p>
    </div>
  </div>
</template>
<script>
import UserIcon from './graphics/UserIcon.vue'
import SmallSurveySpotlightIcon from './graphics/SmallSurveySpotlightIcon.vue'
import AccountIcon from './graphics/AccountIcon.vue'
import dayjs from 'dayjs'
import spotlight_mixins from '../mixins/spotlight_mixins'

export default {
  components: { UserIcon, SmallSurveySpotlightIcon, AccountIcon },
  mixins: [spotlight_mixins],
  props: ['content_asset'],
  computed: {
    formatted_date() {
      const date_string = this.content_asset.verified_at
        ? this.content_asset.verified_at
        : this.content_asset.created_at
      return dayjs(date_string).format('MMMM D, YYYY')
    },
  },
}
</script>
<style lang="sass" scoped>
.date
  line-height: 1
  font-size: 12px
  text-transform: none
  letter-spacing: 0
  margin-top: 16px
  font-weight: 500
  color: hsl(200, 12%, 40%)
</style>
